import { css } from 'styled-components';
import token from 'styled-token';
import { StyledButtonGroup } from '../../components/ButtonGroup/ButtonGroup.styles';
import { StyledFormHelp } from '../../components/FormHelp/FormHelp.styles';
import { StyledLabel } from '../../components/Label/Label.styles';
import { StyledLabeledControl } from '../../components/LabeledControl/LabeledControl.styles';
import { spaceMixin } from '../spaceMixin';
import { spacingMixin } from '../spacingMixin';

/** @class FormFieldMixin */
/** @method */
export var FormFieldMixin = function FormFieldMixin(props) {
  return token({
    labelPaddingBottom: 'FormField.Label.paddingBottom',
    helpMarginTop: 'FormField.Help.marginTop',
    labeledControlMarginLeft: 'FormField.LabeledControl.marginLeft',
    buttonGroupMarginTop: 'FormField.ButtonGroup.marginTop'
  }, function (_ref) {
    var labelPaddingBottom = _ref.labelPaddingBottom,
      helpMarginTop = _ref.helpMarginTop,
      labeledControlMarginLeft = _ref.labeledControlMarginLeft,
      buttonGroupMarginTop = _ref.buttonGroupMarginTop;
    return css(["> ", "{display:block;padding-bottom:", ";}> ", "{margin-top:", ";}> ", "{margin-left:", ";}> ", "{margin-top:", ";}border:0;padding:0;margin:0;", ""], StyledLabel, labelPaddingBottom ? labelPaddingBottom + "px" : spaceMixin(0.5)(props), StyledFormHelp, helpMarginTop ? helpMarginTop + "px" : spaceMixin(0.5)(props), StyledLabeledControl, labeledControlMarginLeft ? labeledControlMarginLeft + "px" : spaceMixin('xs')(props), StyledButtonGroup, buttonGroupMarginTop ? buttonGroupMarginTop + "px" : spaceMixin('xs')(props), spacingMixin(props));
  })(props);
};